import React, { Component, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Navbar from './Navbar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import BlogImage from '../../images/svg/blog.svg';
import ContactImage from '../../images/svg/contact.svg';

const styles = theme => ({
    root: {

    },
    container: {
        width: '90%',
        margin: '10px auto',
        textAlign: 'center'
    },
    line1: {
        margin: '10px 0',
        fontSize: '60px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '35px'
        }
    },
    line2: {
        margin: '10px 0',
        fontSize: '35px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '25px'
        }
    },
    card: {
        padding: '6px',
        cursor: 'pointer'
    },
    cardSection: {
        margin: '0 auto',
        padding: '20px 0',
        backgroundColor: '#f2f4fb',
        textAlign: 'center'
    },
    cardImage: {
        width: '50%',
        height: 'auto',
        margin: '10px 0'
    },
    cardHeading: {
        fontSize: '23px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
        '&::after': {
            display: 'block',
            width: '2em',
            height: '3px',
            background: '#e67300',
            content: '" "',
            margin: '7px auto',
            borderRadius: '2px'
        }
    }
});

class Dashboard extends Component {

    state = { date: new Date() };

    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            date: new Date()
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <Navbar />
                <section className={classes.container}>
                    <Typography variant="h1" className={classes.line1}>Hi, there</Typography>
                    <Typography variant="h1" className={classes.line2}>{`Today is ${this.state.date}`}</Typography>
                    <br /><br />
                    <Grid container spacing={24}>
                        <Grid item xs={12} sm={4}>
                            <Card className={classes.card} onClick={() => {
                                this.props.history.push("/admin/manageBlog");
                            }}>
                                <CardContent className={classes.cardSection}>
                                    <img src={BlogImage} alt="blog" className={classes.cardImage} />
                                    <Typography gutterBottom variant="h4" className={classes.cardHeading}>
                                        Blog</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Card className={classes.card} onClick={() => {
                                this.props.history.push("/admin/manageContact");
                            }}>
                                <CardContent className={classes.cardSection}>
                                    <img src={ContactImage} alt="contact" className={classes.cardImage} />
                                    <Typography gutterBottom variant="h4" className={classes.cardHeading}>
                                        Contact</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </section>
            </Fragment>
        );
    }
}

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Dashboard);